import React, { useCallback, useContext } from 'react'
import { HeaderGlobalNav } from '@grammarly/website-components'
import { useRouter } from 'next/dist/client/router'
import { useBrowserService, useExperimentService, useUserService, useToolsLtvNav } from '../../../../lib/hooks'
import { EventProps, gnarClient } from '../../../../lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { getConfig } from '../../../../config'
import { withPublicAssetUrl } from '../../../../lib/utils/cdn'
import { extractUtmParams } from '../../../../lib/utils/url'

const baseDomain = getConfig().domains.main
const shBaseDomain = getConfig().domains.superhuman

interface HeaderGlobalProps {
  ctas?: React.ReactNode
  secondaryHeader?: React.ReactNode
}

export const HeaderGlobal: React.FC<HeaderGlobalProps> = (props) => {
  const { pageId, slug } = useContext(PageContext)
  const { isAnonymous } = useUserService().currentUser
  const { isMobileOrTablet } = useBrowserService()
  const exp = useExperimentService()
  const { isLtvNavExperiment } = useToolsLtvNav()

  const gnarTrackFn = useCallback(
    (trackEventProps: EventProps) => {
      return gnarClient.track({ ...trackEventProps, pageId, pageSlug: slug })
    },
    [pageId, slug]
  )
  const { query } = useRouter()
  const utmQueryParams = extractUtmParams(query)

  return (
    <HeaderGlobalNav
      clientName="cms"
      baseDomain={baseDomain}
      shBaseDomain={shBaseDomain}
      gnarTrackFn={gnarTrackFn}
      isLoggedIn={!isAnonymous}
      isMobileTablet={isMobileOrTablet}
      secondaryHeader={props.secondaryHeader}
      ctas={props.ctas}
      sticky
      headerItemImages={{ mainStandWithUkraine: withPublicAssetUrl('header/ukraine-grammarly-logo.png') }}
      queryParams={{ utmParams: utmQueryParams }}
      isWhatsNewItemVisible={exp.isWhatsNewHeaderItem_25Enabled}
      isLtvNavCtaFirst={isLtvNavExperiment}
    />
  )
}
